var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "sign_area" } },
    [
      _vm.getHasPayment === "credit"
        ? [
            _c("div", { staticClass: "message_area" }, [
              _c(
                "div",
                { staticClass: "message_area_btn" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function($event) {
                          return _vm.displayTermsPdf()
                        }
                      }
                    },
                    [_vm._v("規約表示")]
                  )
                ],
                1
              ),
              _vm._v(
                "\n      ・ 私は、会員規約の一切の約款について、確認し、承諾しました。"
              ),
              _c("br"),
              _vm._v(
                "\n      ・ 私は、個人情報の取扱いに関する同意条項の内容について、確認し、同意しました。"
              ),
              _c("br"),
              _vm._v(
                "\n      ・\n      私は、貴社による審査の結果入会が認められた場合には、加盟店が私の代わりに当該審査結果を受領することを委託します。"
              ),
              _c("br"),
              _vm._v(
                "\n      ・ 私は、カード番号を受領した場合は、善良なる管理者の注意義務をもって仕様及び保管するものとします。"
              ),
              _c("br"),
              _vm._v(
                "\n      ・ お申込いただいたクレジットカードは、当該加盟店利用専用のハウスカード仕様です。"
              ),
              _c("br"),
              _vm._v(
                "\n      ・ 私は、役務提供契約等のクーリングオフ及び中途解約の内容について、説明を受け、確認し、承諾しました。\n    "
              )
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "checkarea" },
              [
                _c(
                  "el-checkbox",
                  {
                    attrs: { border: "" },
                    model: {
                      value: _vm.check,
                      callback: function($$v) {
                        _vm.check = $$v
                      },
                      expression: "check"
                    }
                  },
                  [
                    _vm._v(
                      "私は、会員規約及び以上の内容を同意のうえ承諾し、貴社のクレジットカードを申し込みます。"
                    )
                  ]
                )
              ],
              1
            )
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.getHasPayment === "installment"
        ? [
            _c("div", { staticClass: "message_area" }, [
              _c(
                "div",
                { staticClass: "message_area_btn" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function($event) {
                          return _vm.displayTermsPdf()
                        }
                      }
                    },
                    [_vm._v("規約表示")]
                  )
                ],
                1
              ),
              _vm._v(
                "\n      ・私は、自社割賦兼保証委託申込の一切の約款について、確認し、承諾しました。"
              ),
              _c("br"),
              _vm._v(
                "\n      ・私は、販売店及び貴社の個人情報の取扱いに関する同意条項の内容について確認し、同意しました。"
              ),
              _c("br"),
              _vm._v(
                "\n      ・私は、役務提供契約等のクーリングオフ及び中途解約の内容について、説明を受け、確認し、承諾しました。\n    "
              )
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "checkarea" },
              [
                _c(
                  "el-checkbox",
                  {
                    attrs: { border: "" },
                    model: {
                      value: _vm.check,
                      callback: function($$v) {
                        _vm.check = $$v
                      },
                      expression: "check"
                    }
                  },
                  [
                    _vm._v(
                      "私は、上記の内容を同意のうえ承諾し、自社割賦兼保証委託申込をします。"
                    )
                  ]
                )
              ],
              1
            )
          ]
        : _vm._e(),
      _vm._v(" "),
      _c("ErrorMessage", { staticClass: "error-step5-required text-center" }),
      _vm._v(" "),
      _c("ErrorMessage", { staticClass: "error-id-exists text-center" }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "box-card-wrapper" },
        [
          _c(
            "el-card",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.check,
                  expression: "check"
                }
              ],
              staticClass: "box-card"
            },
            [
              _c(
                "div",
                {
                  staticClass: "clearfix",
                  attrs: { slot: "header" },
                  slot: "header"
                },
                [
                  _c("span", [
                    _c("i", { staticClass: "fas fa-pencil-alt" }),
                    _vm._v(" 枠内に身分証と同一の署名をしてください")
                  ])
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "body" }, [
                _c("div", { staticClass: "sign_space" }, [
                  _c("canvas", {
                    staticClass: "canvas",
                    attrs: { id: "sign_canvas", "data-canvas": "canvasData" }
                  })
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "clear_btn" },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { icon: "fas fa-eraser", round: "" },
                        on: { click: _vm.eraser }
                      },
                      [_vm._v("書き直す")]
                    )
                  ],
                  1
                )
              ])
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "next" },
        [
          _c(
            "el-button",
            {
              attrs: { type: "primary", icon: "el-icon-arrow-left" },
              on: { click: _vm.backPage }
            },
            [_vm._v("前へ戻る")]
          ),
          _vm._v(" "),
          _c(
            "el-button",
            {
              attrs: {
                type: "primary",
                icon: "el-icon-arrow-right",
                disabled: !(_vm.check && _vm.signed)
              },
              on: { click: _vm.nextPage }
            },
            [_vm._v("次へ進む")]
          )
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }